<mat-form-field class='mxs-input' *ngIf="!formReadonlyMode"
                [formGroup]="form"
                [ngClass]="{'hidden': hidden, 'fitcontent': fitContent}"
                [matTooltip]="getValidationHint() | translate"
                [matTooltipClass]="'mxs-error-ttip'"
>
  <mat-label>{{getLabel() | translate}}</mat-label>
  <input matInput (keyup)="getValue()"
         [name]="name"
         [errorStateMatcher]=errorService
         [formControlName]="name"
         [readonly]=readonly
         [required]="required"
  />
  <button *ngIf="isDisplayed() || !readonly" matSuffix mat-icon-button type="button" aria-label="Clear"
          (click)="resetValue($event)">
    <mat-icon>clear</mat-icon>
  </button>
  <mat-hint>{{getHint() | translate}}</mat-hint>
  <mat-error *ngFor="let error of getValidationMessages(true)">
    {{getError(error) | translate}}
  </mat-error>
</mat-form-field>

<mat-list-item class="mxs-readonly" *ngIf="formReadonlyMode"
               [ngClass]="{'hidden': hidden, 'fitcontent': fitContent}">
  <div class="mxs-readonly_label">{{getLabel() | translate}}</div>
  <div class="mxs-readonly_input" *ngIf="isViewUrl()">
      <a target="_blank" [href]="openViewUrl()">{{getDisplayValue(form.controls[name].value)}}</a>
  </div>
  <div class="mxs-readonly_input" *ngIf="!isViewUrl()">{{getDisplayValue(form.controls[name].value)}}</div>
</mat-list-item>
